/**
 * The stored global messages types supported by this component.
 * @type {Object<String>}
 */
export const STORED_MESSAGES_TYPES = {
    COOKIE_APPROVAL: 'cookie_approval'
};
